import Modal from "components/Modal";
import useLabels from "hooks/useLabels";

type ConfirmDeleteListModalProps = {
  open?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

/**
 * @component ConfirmDeleteListModal
 * @description Component for confirm delete list modal
 * @example
 * return (
 *   <ConfirmDeleteListModal
 *    open={true}
 *    onClose={fn}
 *   />
 * )
 */
function ConfirmDeleteListModal({
  open,
  onClose,
  onConfirm,
}: ConfirmDeleteListModalProps) {
  const [modalLabels] = useLabels("confirm-bookmark-list-modal");

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={modalLabels["do-you-want-to"]}
      onButtonClicked={onConfirm}
      buttonText={modalLabels["button-text"]}
      subtitle={modalLabels["description"]}
    ></Modal>
  );
}

export default ConfirmDeleteListModal;
